import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useSelector } from "react-redux";

const Shippers = () => {
    const { id } = useParams();

    const permissions = useSelector((state) => state.status.permissions);

    const { data: shippers, refetch: refetchShippers } = useGetPageQuery("shippers?active=" + id);
    const [deleteShippers, { isLoading, isError }] = useSendFormMutation();

    const [shippersList, setShippersList] = useState([]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setShippersList([...shippersList, e.target.value]);
        } else if (!e.target.checked) {
            setShippersList([...shippersList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteShippersHandler = async () => {
        for (const user of shippersList) {
            await deleteShippers({ body: {}, url: "shippers/" + user, method: "DELETE" });
        }

        await refetchShippers();

        if (!isError) {
            succsesDataDeleteAlert();
        }
    };

    const checkAllHandler = () => {
        setShippersList(shippers.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            await refetchShippers();
        };
        refetch();
    }, [shippers]);

    return (
        <>
            {shippers && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div className="header">
                                <h1>Постачальники</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/shipper"} className="add btn btn-primary">
                                        Додати постачальника
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <ul className="nav-bordered nav nav-tabs mb-3">
                            <li className="nav-item">
                                <Link to={"/shippers/1"} className={+id === 1 ? "nav-link active" : "nav-link"}>
                                    <span className=" d-lg-block">Активні</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to={"/shippers/0"} className={+id === 0 ? "nav-link active" : "nav-link"}>
                                    <span className=" d-lg-block">Деактивовані</span>
                                </Link>
                            </li>
                        </ul>
                        <div id="list_form">
                            <a className="check_all" onClick={checkAllHandler}>
                                Виділити все
                            </a>
                            <table className="table table-striped ui-sortable">
                                <thead>
                                    <tr>
                                        <th data-field="move"></th>
                                        <th data-field="check"></th>
                                        <th data-field="id">ID</th>
                                        <th data-field="user_name">Назва</th>
                                        <th data-field="user_name">Коротка назва</th>
                                        {/* <th data-field="user_phone">Баланс</th> */}
                                        <th data-field="user_phone" className="no-mobile">
                                            Статус
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shippers.data.map((shipper) => {
                                        return (
                                            <tr key={shipper.id}>
                                                <td className="td_move fit">
                                                    <input type="hidden" name="positions[1]" value="1" />
                                                    <i className="bi bi-list"></i>
                                                </td>
                                                <td className="check_area text-right">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={shippersList.includes(shipper.id.toString())}
                                                            value={shipper.id}
                                                            onChange={(e) => listCheckHandler(e)}
                                                        />
                                                        <label className="custom-control-label" for="check_u1">
                                                            &nbsp;
                                                        </label>
                                                    </div>
                                                </td>
                                                <td className="fit">#{shipper.id}</td>
                                                <td>
                                                    <Link to={"/shipper/" + shipper.id}>{shipper.title}</Link>
                                                </td>
                                                <td>{shipper.title_short}</td>
                                                {/* <td className="fit"><a href="/shipper_balance?id=1">0</a></td> */}
                                                <td className="fit no-mobile">Активний</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {permissions.includes("shipper_edit") || permissions.includes("all") ? (
                                <div className="d-flex">
                                    <select name="action" className="form-select" style={{ width: "auto" }}>
                                        <option value="delete">Видалити</option>{" "}
                                    </select>
                                    <button className="btn btn-info mx-3" onClick={deleteShippersHandler}>
                                        {isLoading ? "Завантаження" : "Виконати"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Shippers;
